import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="branding"
export default class extends Controller {
  static targets = [
    "namespaceFields", 
    "subdomainFields",
    "namespaceInput",
    "subdomainInput",
    "namespacePreview",
    "subdomainPreview"
  ]

  connect() {
    this.updateFieldsVisibility()
    this.updatePreview()
  }

  toggleOption(event) {
    this.updateFieldsVisibility()
  }

  updateFieldsVisibility() {
    const selectedValue = this.getSelectedBrandingType()
    
    this.namespaceFieldsTarget.classList.toggle("hidden", selectedValue !== "namespace")
    this.subdomainFieldsTarget.classList.toggle("hidden", selectedValue !== "subdomain")
  }

  updatePreview() {
    if (this.hasNamespacePreviewTarget && this.hasNamespaceInputTarget) {
      const namespace = this.namespaceInputTarget.value || '[namespace]'
      this.namespacePreviewTarget.textContent = `catchhook.app/hooks/${namespace}.checkout`
    }
    
    if (this.hasSubdomainPreviewTarget && this.hasSubdomainInputTarget) {
      const subdomain = this.subdomainInputTarget.value || '[subdomain]'
      this.subdomainPreviewTarget.textContent = `${subdomain}.catchhook.app/hooks/checkout`
    }
  }

  getSelectedBrandingType() {
    const radioButtons = this.element.querySelectorAll('input[name*="branding_type"]')
    const selected = Array.from(radioButtons).find(radio => radio.checked)
    return selected ? selected.value : null
  }
} 